import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useAppDispatch} from '../Contexts/AppContext'
import {useQuery} from 'react-query'
import {getAlphaNames} from '../api'
import ListTable from '../components/ListTable/ListTable'
import EventEmitter from '../Utils/EventEmitter'
import SaveAlphaNameModal from '../components/modals/SaveAlphaNameModal'
import {useTranslation} from "react-i18next";
import DisabledValue from '../components/DisabledValue';

const AlphaNames = () => {
    const { t } = useTranslation();
    const {setBreadcrumbs, setSection} = useAppDispatch()
    const [pagination] = useState(null)
    const [sorting, setSorting] = useState([])
    const [,setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [list, setList] = useState([])
    const [showCreateModal, setShowCreateModal] = useState(false)
    const tableColumns = useMemo(() => {
        return [
            {
                Header: t('Alpha Names.Alpha Name'),
                accessor: 'alpha_name',
                Cell: ({value, row}) => row.original.default ? <DisabledValue value={value} /> : value
            },
            {
                Header: t('Alpha Names.Type'),
                accessor: 'type',
                Cell: ({value, row}) => row.original.default ? <DisabledValue value='Default' /> : '-'
            },
            {
                Header: t('Alpha Names.Status'),
                accessor: 'active',
                className: 'text-right',
                Cell: ({value, row}) => {
                    const label = (
                        <div className={value ? "chipLike success" : "chipLike"}>
                            <span className="chipLikeLabel">{value ? 'Active' : 'Inactive'}</span>
                        </div>
                    )
                    return row.original.default ? <DisabledValue value={label} /> : label
                }
            },
        ]
    }, [t])

    const {setContextMenu} = useAppDispatch()

    useEffect(() => {
        setContextMenu([
            // {
            //     label: 'Add New Alpha Name',
            //     icon: PlusCircle,
            //     action: () => EventEmitter.emit('AlphaNameCreate'),
            //     disabled: true
            // },
        ])
    }, [setContextMenu])

    useEffect(() => {
        const onEvent = () => setShowCreateModal(true)

        const listener = EventEmitter.addListener('AlphaNameCreate', onEvent)
        return () => { listener.remove() }
    }, [])

    const alphaNamesRequest = useQuery(
        ['alphaNames', sorting],
        () => getAlphaNames(),
        {keepPreviousData: true}
    )


    useEffect(() => {
        if (alphaNamesRequest.isSuccess) setList(alphaNamesRequest.data.data)
    },[alphaNamesRequest.isSuccess, alphaNamesRequest.data])

    //breadcrumbs
    useEffect(() => {
        setBreadcrumbs([
            {label: t('Alpha Names.Settings'), link: '/settings'},
            {label: t('Alpha Names.Alpha Name')}
        ])
        setSection('settings')
    }, [setBreadcrumbs, setSection, t])

    const handleLimitChange = useCallback((l) => {
        setPage(1)
        setLimit(l)
    }, [setPage, setLimit])

    return (
        <div className="pageHolder">
            <ListTable
                columns={tableColumns}
                data={list}
                loading={alphaNamesRequest.isLoading}
                fetching={alphaNamesRequest.isFetching}
                onSort={setSorting}
                emptyDataText={t('Alpha Names.No Alpha Names Found')}
                pagination={pagination}
                pageLimit={limit}
                onPageChange={setPage}
                onLimitChange={handleLimitChange}
                disableSearchBlock={true}
            />
            <SaveAlphaNameModal
                open={showCreateModal}
                handleClose={() => {
                    setShowCreateModal(false)
                }}
            />
        </div>
    )
}

export default AlphaNames
